import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_LIST = {
  'list': [],
  'loading': false,
};

export const waitHappyVehicles = (state, action) => {
  return createReducer(INITIAL_STATE_LIST, {
    [ActionTypes.FETCHING_LIST_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LIST_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_LIST_WAIT_HAPPY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};


const INITIAL_STATE_WEEK_LIST = {
  'list': [],
  'loading': false,
};

export const weeksWaitHappy = (state, action) => {
  return createReducer(INITIAL_STATE_WEEK_LIST, {
    [ActionTypes.FETCHING_LIST_WEEK_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LIST_WEEK_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_LIST_WEEK_WAIT_HAPPY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
